// removed by extract-text-webpack-plugin
module.exports = {"promoCodeCampaignText":"G11a06c G3c3c24","inputFieldContainer":"G34b4b9"};